import { render, staticRenderFns } from "./TencentCloudChooseimg.vue?vue&type=template&id=73bc13dd&scoped=true"
import script from "./TencentCloudChooseimg.vue?vue&type=script&lang=js"
export * from "./TencentCloudChooseimg.vue?vue&type=script&lang=js"
import style0 from "./TencentCloudChooseimg.vue?vue&type=style&index=0&id=73bc13dd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bc13dd",
  null
  
)

export default component.exports